// extracted by mini-css-extract-plugin
export default {"vidalInfosTooltip":"DocumentInstanceBanners_vidalInfosTooltip__MTcDM"};